import { createRouter, createWebHistory } from "vue-router";
import { useToast } from "vue-toastification";
import { getAccessToken, getRefreshToken } from "@/helpers/token";
import userRoutes from "@/router/userRoutes"
import accountingRoutes from "@/router/accountingRoutes";
import purchaseRoutes from "@/router/purchaseRoutes";
import inventoryRoutes from "@/router/inventoryRoutes";
import saleRoutes from "@/router/saleRoutes";
import crmRoutes from "@/router/crmRoutes";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("@/pages/DashboardPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/pages/LandingPage.vue"),
    meta: { requiresLayout: false },
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("@/pages/ReportPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/LoginPage.vue"),
    meta: { requiresLayout: false },
  },
  ...userRoutes,
  ...accountingRoutes,
  ...purchaseRoutes,
  ...inventoryRoutes,
  ...saleRoutes,
  ...crmRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const toast = useToast();
  const isAuthenticated = isUserLoggedIn();

  if (to.path === "/login" && isAuthenticated) {
    toast.info("You are already logged in");
    next("/");
    return;
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    toast.error("You must be logged in to access this page");
    next({ path: "/login", query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

function isUserLoggedIn() {
  return !!(getAccessToken() || getRefreshToken());
}

export default router;
